/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$(document).ready(function () {

    articlePageSlider();
    productPageSlider();
    setPopupTabsHeight();

    /* Sign Up forms events for GA */
    $('.Footer__Newsletter .Form__Submit').on('click', function(){
        ga('send', 'event', {
            eventCategory: 'Email Sign-Up',
            eventAction: 'Click',
            eventLabel: 'Email Sign-Up Footer'
        });
    });
    $(document).on('click', '#omnisend-dynamic-container [type="submit"]', function(){
        ga('send', 'event', {
            eventCategory: 'Email Sign-Up',
            eventAction: 'Click',
            eventLabel: 'Email Sign-Up Pop-Up'
        });
    });

    $('.tabs .tab').click(function() {
        $(".tabs .tab").removeClass("active").eq($(this).index()).addClass("active");
        $(".tab-item").hide().eq($(this).index()).fadeIn();

        if ($(window).width() <= 640 && $(this).closest('body').hasClass('template-product')) {
            var parent = $(this).closest('.tabs');
            parent.find('.tabs-wrapper').removeClass('open');
            parent.find('.tab_active_mobile span').text($(this).text());
        }
    });

    $('.template-product .tab_active_mobile').on('click', function() {
        if ($(window).width() <= 640) {
            $(this).next('.tabs-wrapper').addClass('open');
        }
    });

    $('.popup_tabs .tab_title').on('click', function() {
        var tab_name = $(this).data('tab');
        $(this).closest('.popup_tabs').find('.tab_title').removeClass('active');
        $(this).addClass('active');

        $(this).parent().parent().find('.popup_tabs_panels .panel_item').removeClass('active');
        $(this).parent().parent().find('.popup_tabs_panels .panel_item[data-tab="' + tab_name + '"]').addClass('active');
    });

    $('.gift-note').click(function(e) {
        e.preventDefault();
        $('.thank-you-title').fadeOut();
        $('.gift-close__btn').addClass('popup_fast-close').removeClass('gift-close__btn');
        openPopup('gift-note', $(this).attr('data-main-product'));
    });

    $('body').on('click', '.popup_fast-close', function(e) {
        e.preventDefault();
        closePopup();
    });

    /*$('.close-popup').click(function() {
        closePopup();
    });*/

    /*$('.popup--overlay').on('mousedown', function(e) {
        var div = $(".gift-note--popup");
        if (!div.is(e.target)
            && div.has(e.target).length === 0) {
            closePopup();
        }
    });*/

    /*$('.gift-note__btn').click(function (e) {
        e.preventDefault();
        closePopup();
    });*/

    $('#gift-note').bind('keyup change input copy paste cut', function() {
        if ($(this).val() == '') {
            $('.popup__link.gift-note').text('Add a Gift Note');
            $('.letter_count span').text(0);
        } else {
            $('.popup__link.gift-note').text('Change a Gift Note');
            var count = $(this).val().length;
            $('.letter_count span').text(count);
        }
    });

    $('.open_blessing').click(function(e) {
        e.preventDefault();
        openPopup('blessing', $(this).attr('data-main-product'));
    });

    $('.blessing__btn').on('click', function() {
        var blessingParentBlock = $(this).closest('.gift-note--description');

      /*
        if (blessingParentBlock.hasClass('added-to-cart')) {
            addRemoveBlessing(blessingParentBlock, true);
            checkBlessing();
        } else {
            var blessingValue = blessingParentBlock.find('.blessing_value').val();
            if (blessingValue != null) {
                addRemoveBlessing(blessingParentBlock, false);
                checkBlessing();
            }
        }
*/addRemoveBlessing(blessingParentBlock, false);
      
    });

    $('select[name="blessing_value"]').on('change', function() {
        var blessingParentBlock = $(this).closest('.gift-note--description');
        addRemoveBlessing(blessingParentBlock, true);
        checkBlessing();


var image = $(this).find('option:selected').data('image');
var title = $(this).find('option:selected').data('title');
var link = $(this).find('option:selected').data('link');
var description = $(this).find('option:selected').data('description');
var price = $(this).find('option:selected').data('price');

$('.gift-note--popup img.gift').attr('src',image);
$('.gift-note--popup p.product-title.blessing').text(title);
$('.gift-note--popup p.product-link a').text(title); 
$('.gift-note--popup p.product-link a').attr('href',link);
$('.gift-note--popup p.product-description.blessing').text(description);    
$('.gift-note--popup p.product-price.blessing').html(price); 

document.querySelector("#blessing-1").value = parseInt($(this).val());
    });

    function addRemoveBlessing(blessingBlock, addedToCart) {
        if (addedToCart) {
            blessingBlock.removeClass('added-to-cart');
            blessingBlock.find('.product-blessing').val('');
            blessingBlock.find('.blessing__btn').text('Add your blessing');
        } else {
            blessingBlock.addClass('added-to-cart');
            blessingBlock.find('.product-blessing').val(blessingBlock.find('.blessing_value').val());
            //blessingBlock.find('.blessing__btn').text('Remove');
            localStorage.setItem('added-to-cart','yes');
        }
    }

    function checkBlessing() {
        var blessingBlock = $('#add-blessing .gift-note--description');
        var blessingBlockAdded = false;
        blessingBlock.each(function(i, block) {
            if ($(block).hasClass('added-to-cart')) {
                blessingBlockAdded = true;
            }
        });

      blessingBlockAdded = false;

      
        if (blessingBlockAdded) {
            $('.popup__link.open_blessing').text('Blessing added');
        } else {
            $('.popup__link.open_blessing').text('Add a Blessing');
        }
    }

    function openPopup(type, mainProductID) {
        setPopupGiftNoteTabsHeight();
        $('body').addClass('noscroll');
        var popup = $('.popup--overlay');
        popup.fadeIn();
        popup.find('.tab_title[data-tab="' + type + '"]').trigger('click');
        if (mainProductID != undefined) {
            popup.find('.additional_add-to-cart').attr('data-main-product', mainProductID);
        }
    }

    function closePopup() {
        $('body').removeClass('noscroll');
        $('.popup--overlay').fadeOut();
    }

    if ($(window).width() < 640) {
        $(".accordion__content").slideUp(400);
        $(".accordion__title").removeClass("accordion-active");
    }

    $('.product_description--accordion .accordion__title').on('click', function(e) {
        e.preventDefault();
        var $this = $(this);

        if (!$this.hasClass("accordion-active")) {
            $(".accordion__content").slideUp(400);
            $(".accordion__title").removeClass("accordion-active");
        }

        $this.toggleClass("accordion-active");
        $this.next().slideToggle();
    });

    $('.additional_add-to-cart').on('click', function() {
        var giftID = $(this).closest('#add-gift-note').find('.variant-id').val();
        var giftNote = $(this).closest('#add-gift-note').find('#gift-note').val();
        var uniqId = new Date().valueOf();

        var mainProduct = $(this).attr('data-main-product');

        if (giftNote != '') {
 console.log(1);
          
            $.ajax({
                type:     'POST',
                url:      '/cart/add.js',
                data:     {
                    id:         giftID,
                    quantity:   1,
                    properties: {
                        '_additional_product_type': "gift note",
                        'text': giftNote,
                        '_uniqID': uniqId
                    }
                },
                dataType: 'json',
                success:  function () {
                    $.ajax({
                        type:     'POST',
                        url:      '/cart/change.js',
                        data:     {
                            id:       mainProduct,
                            properties: {
                                '_uniqID': uniqId,
                                'Gift Note': giftNote
                            }
                        },
                        dataType: 'json',
                        success:  function () {
                            location.reload();
                        }
                    });
                }
            });

          
        }
    });

    function articlePageSlider() {
        /* Article page slider */
        var $slider = $('.article-content-slider');
        if ($slider.length) {
            $slider.slick({
                slidesToShow:   1,
                slidesToScroll: 1,
                arrows:         false,
                fade:           false,
                dots:           true,
                autoplay:       true,
                autoplaySpeed:  4000
            });
        }
    }

    function productPageSlider() {
        /* Product page slider */
        var $slider = $('.product_page_slider');

        $slider.on('afterChange', function(slick, currentSlide, index){
            if ($(slick.currentTarget).find('.slick-current').hasClass('video-wrapper')) {
                $(slick.currentTarget).find('.slick-current').find('video').get(0).play();
            }
        });

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            if ($(event.currentTarget).find('.slick-current').hasClass('video-wrapper')) {
                $(event.currentTarget).find('.slick-current').find('video').get(0).pause();
            }
        });

        if ($slider.length && $slider.children().length > 0) {
            $slider.slick({
                slidesToShow:   1,
                arrows:         true,
                dots:           false,
                centerMode:     true,
                centerPadding:  '0',
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            dots:   true,
                            arrows: false
                        }
                    }
                ]
            });
        }
    }

    function setPopupTabsHeight() {
        var popupTabPanels = $('.Modal .popup_tabs_panels .panel_item');
        var height = popupTabPanels.eq(0).height();
        var width = popupTabPanels.eq(0).width();

        popupTabPanels.each(function(i, item) {
            if ($(this).height() > height) {
                height = $(this).height();
            }
            if ($(this).width() > width) {
                width = $(this).width();
            }
        });
        popupTabPanels.height(height);

        if ($(window).width() > 640) {
            popupTabPanels.width(width);
        }
    }

    function setPopupGiftNoteTabsHeight() {
        setTimeout(function() {
            var popupGiftTabPanels = $('.gift-note--popup .popup_tabs_panels .panel_item');
            var height = popupGiftTabPanels.eq(0).height();

            popupGiftTabPanels.each(function(i, item) {
                if ($(this).height() > height) {
                    height = $(this).height();
                }
            });
            popupGiftTabPanels.height(height);
        }, 300);
    }
});








var iphone = (/iPad|iPhone|Mac|iPod/.test(navigator.userAgent));
if(iphone)
{
  $('body').addClass('iphone');
}


function removePopup()
  {
    $('body').removeClass('noscroll');
        $('.popup--overlay').fadeOut();
  }
var addToCartButton = document.querySelector('.ProductForm__AddToCart');
function closeAll()
  {
    removePopup(); 
document.dispatchEvent(new CustomEvent('theme:loading:end'));
addToCartButton.removeAttribute('disabled');
  }
function addGift()
  {
    var blessingProduct1ID = document.querySelector('#blessing-1').value;
var productItem = {
'id': blessingProduct1ID,
'quantity': 1,
'properties': {
'_additional_product_type': 'blessing'
}
}
$.ajax({
type: 'POST',
url: '/cart/add.js',
data:productItem,
dataType: 'json', 
success: function (data) { 
 

closeAll();

document.dispatchEvent(new CustomEvent('product:added', {
bubbles: true,
detail: {
variant: 1,
quantity: 1
}
}));
  
},error:function(){
   closeAll();
}
});
  }
function giftProduct()
  {
var titleBlessingToBeAdded = $("#blessing_value_1 option:selected").data('titleitem');
var sameBelessingInCart = $(".CartItem.giftProduct."+titleBlessingToBeAdded);
 
var normalPdps = $('.CartItem:not(.noteProduct):not(.giftProduct)').length;   
if(document.querySelector('#blessing-1').value == "")
{
document.querySelector("#blessing_value_1").style.borderColor="red";
setTimeout(function(){
document.querySelector("#blessing_value_1").style.borderColor="inherit"},2000);
  return;
}

addToCartButton.setAttribute('disabled', 'disabled');
document.dispatchEvent(new CustomEvent('theme:loading:start'));
    
var id = $('h1.ProductMeta__Title.Heading.u-h2').data('id');
if($('.CartItem[data-id="'+id+'"]').length > 0)
{
/* just gift*/

/*if gift is already there, removing that first*/
if(sameBelessingInCart.length>0)
{
  closeAll();document.querySelector('#section-header a[href="/cart"]').click()
}else{
/* no need of delay, as blessing is not there before*/
addGift(); 
}    
}else{ 
  
if(sameBelessingInCart.length>0)
{ 
//if(document.querySelector(".CartItem.giftProduct."+titleBlessingToBeAdded))document.querySelector(".CartItem.giftProduct."+titleBlessingToBeAdded+" a.reduce").click();
 
/*add main product*/ 
var dataMain = $('.Product__Info form.ProductForm').serialize();
$.ajax({
type: 'POST',
url: '/cart/add.js',
data:dataMain,
dataType: 'json', 
success: function (data) { 
 closeAll();
} ,error:function(){
   closeAll();
}
});  
}else{ 
/* give some delay*/
setTimeout(function(){ 
/*add main product*/ 
var dataMain = $('.Product__Info form.ProductForm').serialize();
$.ajax({
type: 'POST',
url: '/cart/add.js',
data:dataMain,
dataType: 'json', 
success: function (data) { 

addGift();
/* both added now*/

} ,error:function(){
   closeAll();
}
}); 
},1000);
}
  
 
}  
}